import { FC } from "react";
import { ListItemText, Stack, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { ProviderIcon } from "@/components/common/ProviderIcon";
import { ProviderType } from "@/services/cloudchipr.api";
import { useAppSelector } from "@/store/hooks";
import { commitmentsProviderOrganizationsCountsSelector } from "@/store/commitments/selectors/organisations/commitmentsProviderOrganizationsCountsSelector";
import { getProviderName } from "@/utils/helpers/providers/getProviderName";

interface CommitmentOrganizationSelectMenuItemProps {
  title?: string;
  disabled?: boolean;
  provider?: ProviderType;
}

export const CommitmentOrganizationSelectMenuItem: FC<
  CommitmentOrganizationSelectMenuItemProps
> = ({ title, disabled, provider }) => {
  const orgsCount = useAppSelector(
    commitmentsProviderOrganizationsCountsSelector,
  );
  const isSingle = orgsCount?.[provider ?? "aws"] === 1;

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      {provider && <ProviderIcon provider={provider} />}

      <ListItemText
        primary={
          isSingle && provider
            ? getProviderName(provider ?? "aws", { title: true })
            : (title ?? "Other Accounts")
        }
        primaryTypographyProps={{ variant: "body1" }}
      />

      {disabled && (
        <Tooltip
          arrow
          placement="top"
          title="This organization has no active commitments."
        >
          <InfoOutlinedIcon fontSize="small" color="action" />
        </Tooltip>
      )}
    </Stack>
  );
};
